import { render, staticRenderFns } from "./SGKExitDetail.vue?vue&type=template&id=02771c60&"
import script from "./SGKExitDetail.vue?vue&type=script&lang=js&"
export * from "./SGKExitDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports